import React from "react";
import I18n from "../../../../commons/I18n/I18n";
import VehicleModel from "../../../../commons/model/VehicleModel";
import { generateRoute } from "../../../../commons/utils/Router";
import Th from "../../../../components/table/Th";
import I18nKeys from "../../../../I18n/I18nKeys";
import { ROUTE_ADMIN_VEHICLE_MODEL_DETAIL } from "../../../../routing/Routes";
import { goToRoute } from "../../../../utils/Router";
import { OnSortHandler, SortState } from "../../../../utils/Sort";

interface VehicleModelListTableProps {
    data: VehicleModel[];
    error: string;
    onSort: OnSortHandler;
    sort: SortState;
    renderSelectTd?: (itemId: string)=> React.ReactNode;
}

const goToItemDetail = (itemId: string): void => {
  goToRoute(generateRoute(ROUTE_ADMIN_VEHICLE_MODEL_DETAIL, {
    id: itemId,
  } ));
};

export default class VehicleModelListTable extends React.Component<VehicleModelListTableProps> {
  public render(): React.ReactNode {
    const {data, renderSelectTd} = this.props;

    return (
      <table className="table table-hover">
        <thead>{this.renderTH()}</thead>
        <tfoot>{this.renderTH()}</tfoot>
        <tbody>
          {data && data.map((vehicleModel: VehicleModel) => (
            <tr key={vehicleModel.id}
              onClick={() => goToItemDetail(vehicleModel.id)}
              className={"tr-cursor"}
            >
              {renderSelectTd ? renderSelectTd(vehicleModel.id) : null}
              <td>
                {vehicleModel.id}
              </td>
              <td>
                {vehicleModel.name}
              </td>
              <td>
                {vehicleModel.vehicle_brand ? vehicleModel.vehicle_brand.name : ""}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  private renderTH(): React.ReactNode {
    const {sort, children, onSort} = this.props;
    const commonProps = {
      sort,
      onSort,
    };

    return (
      <tr>
        {children}
        <Th text={I18n.tr(I18nKeys.IDENTIFICADOR)}
          columnName={"id"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.NOMBRE)}
          columnName={"name"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.MARCA)}
          columnName={"vehicle_brand.name"}
          {...commonProps}
        />
      </tr>
    );
  }
}
